<template>
  <div class="xscontainer jsjiesh">
    <div class="nnklcv">
      <SearchBox style="width: 100%"  @search="chaxunfangan"></SearchBox>
      <div class="lll" v-for="(item,index) in ssfas" @click="gotoxiangqing(item.id)">
        <p class="biaoti2">{{item.biaoti}}</p>
        <div class="mmmdfssd" style="margin-top:10px;" v-html="item.neirong"></div>
        <div class="linejjj"></div>
      </div>
      <el-pagination
          align="center"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="currentPage1"
          :page-sizes="[3, 5, 8, 10]"
          :page-size="pagesize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1">
      </el-pagination>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
import SearchBox from "@/components/lianmeng/common/SearchBox";
export default {
  components:{
    SearchBox
  },
  data() {
    return {
      ssfas:[],
      pagesize1:3,
      currentPage1: 1,
      total1:0,
      currentText:'',
      fwcishu:0
    };
  },
  mounted() {
    this.queryShishifangan();
  },
  created() {
    this.tongji('方案列表');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    chaxunfangan(stext){
      this.currentText = stext;
      this.queryShishifanganLike(stext)
    },
    queryShishifanganLike(stext){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shishi/tShishifangan/list?_t='+new Date().getTime()+'&column=pxh&biaoti=*'+stext+'*&order=desc&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.ssfas  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    handleClick(){

    },
    handleSizeChange1(val) {
      this.pagesize1 = val;
      if(this.currentText){
        this.queryShishifanganLike(this.currentText);
      }else{
        this.queryShishifangan();
      }
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      if(this.currentText){
        this.queryShishifanganLike(this.currentText);
      }else{
        this.queryShishifangan();
      }
    },
    queryShishifangan(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shishi/tShishifangan/list?_t='+new Date().getTime()+'&column=pxh&order=desc&pageNo='+this.currentPage1+'&pageSize='+this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.ssfas  = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
    gotoxiangqing(id){
      this.$router.push({path:'/ssxq',query:{id:id}});
    }
  }
};
</script>

<style scoped>
.nnklcv{
  display: flex;
  flex-direction: column;
  gap:1rem;
  width: 60%;
}

.tabcss55{
  width: 40%;
  display: flex;
  justify-content: start;
}
.linkcs6444{
  width: 33.33%;
  font-size: 1rem;
  color: #8a8a8a;
}
.linkcs6444:hover{
  color: #46abf5;
  cursor: pointer;
}
.middiv{
  background-color: #edf7ff;
  width: 100%;
  height: 10rem;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 2rem 4rem 2rem;
}
.jjkdkfd{
  color: #137af4;
  font-weight: bold;
  font-size: 16px;
}
.mkdl{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.tdd {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  box-shadow: 0px 0px 1px 0px #55a2da;
}
.klsd{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
}
.tkkjk{
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 0.15rem;
}
.nkdlkld{
  letter-spacing: 0.15rem;
}
.midleft{
  width: 75%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.wzcss{
  letter-spacing: 1px;
  line-height: 32px;
}
.wzcss:hover{
  cursor: pointer;
  color: #137af4;
}
.midright{
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.xiadiv{
  width: 100%;
  display: flex;
  gap: 2rem;
}
.upcs{
  width: 100%;
  height: 8rem;
  background: -webkit-linear-gradient(bottom, #fff, #1e5de9);
  background: -moz-linear-gradient(bottom, #fff, #1e5de9);
  background: linear-gradient(to top, #fff, #1e5de9);
  display: flex;
  align-items: end;
}
.upin{
  width: 100%;
  height: 2rem;
  background-color: #373636;
  opacity: 0.5;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.neewre{
  margin: 2rem 0 2rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.zhengwen_grey1:hover{
  cursor: pointer;
  color: #137af4;
  text-decoration: underline;
}
.linejjj{
  width: 100%;
  height: 1px;
  /*border-bottom: 1px dashed #137af4;*/
  border-bottom: 1px solid #e4e4e5;
  margin: 1rem 0 1rem 0;
}
.lll{
  display: flex;
  flex-direction: column;
}
.lll:hover{
  cursor: pointer;
  text-decoration: underline;
}

.mmmdfssd{
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 2.1rem;
  width: 100%;             /* 必须有明确宽度 */

  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

}
</style>
